export default () => {
  let sliders = document.querySelectorAll('.js-slider');

  sliders.forEach(slider => {
    let slidesPerView = parseInt(slider.getAttribute('data-slides-per-view')) || 1;
    let spaceBetween  = parseInt(slider.getAttribute('data-space-between')) || 0;
    let isLoop        = slider.getAttribute('data-loop') === 'true';
    let isPagination  = slider.getAttribute('data-pagination') === 'true';
    let isNavigation  = slider.getAttribute('data-navigation') ? slider.getAttribute('data-navigation') === 'true' : true;
    let isButtons     = slider.getAttribute('data-buttons') === 'true';

    let options = {
      slidesPerView: 1,
      spaceBetween:  spaceBetween,
      loop:          isLoop,
      speed:         500,
      watchOverflow: true,

      breakpoints: {
        480:  {
          slidesPerView: slidesPerView > 1 ? 2 : 1
        },
        1024: {
          slidesPerView: slidesPerView
        }
      }
    };

    if (isPagination) {
      let paginationDiv       = document.createElement('div');
      paginationDiv.className = 'swiper-pagination';

      slider.appendChild(paginationDiv);

      options.pagination = {
        el:        slider.querySelector('.swiper-pagination'),
        clickable: true
      };
    }

    if (isNavigation || isButtons) {
      let controlsDiv       = document.createElement('div');
      controlsDiv.className = 'slider__controls';

      let prevButton       = document.createElement('button');
      prevButton.type      = 'button';
      prevButton.className = 'swiper-button-prev';

      let nextButton       = document.createElement('button');
      nextButton.type      = 'button';
      nextButton.className = 'swiper-button-next';

      if (isButtons) {
        prevButton.innerHTML = '<p>Prev</p>';
        nextButton.innerHTML = '<p>Next</p>';
      }

      controlsDiv.appendChild(prevButton);
      controlsDiv.appendChild(nextButton);
      slider.appendChild(controlsDiv);

      options.navigation = {
        prevEl: slider.querySelector('.swiper-button-prev'),
        nextEl: slider.querySelector('.swiper-button-next')
      };
    }

    new Swiper(slider, options);
  });
}
